"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const FAQS: FaqItem[] = [{
  id: "faq-hours",
  question: "Für wie viele Stunden kann ich einen privaten Fahrer buchen?",
  answer: "Sie können flexible Pakete für 2, 4, 6 oder 8 Stunden buchen – ganz nach Ihrem Zeitplan und Ihren Reiseplänen in Hurghada und Umgebung."
}, {
  id: "faq-destinations",
  question: "Kann ich meine eigenen Reiseziele und Zwischenstopps wählen?",
  answer: "Ja. Sie haben die volle Freiheit, Ihre Reiseroute, Zwischenstopps, Besichtigungen und Strecken ohne vordefinierte Vorgaben selbst zu bestimmen."
}, {
  id: "faq-wait",
  question: "Wartet der Fahrer, während ich Sehenswürdigkeiten oder Orte besuche?",
  answer: "Ja. Ihr persönlicher Fahrer und das Fahrzeug stehen Ihnen an jedem Zielort während des gesamten gebuchten Zeitraums durchgehend auf Abruf zur Verfügung."
}, {
  id: "faq-return",
  question: "Kann ich auch eine Rückfahrt oder Rundfahrt buchen?",
  answer: "Ja. Rückfahrten, mehrere Zwischenstopps und Rundfahrten sind innerhalb Ihrer gebuchten Mietdauer vollständig abgedeckt."
}, {
  id: "faq-hotel",
  question: "Kann die Fahrt direkt an meinem Hotel beginnen?",
  answer: "Ja. Wir bieten einen direkten Tür-zu-Tür-Abhol- und Bringservice von Hotels, Ferienwohnungen und Resorts an."
}, {
  id: "faq-whatsapp",
  question: "Kann ich über WhatsApp buchen?",
  answer: "Ja. Sie können Verfügbarkeiten anfragen, Details abstimmen und Ihre Privatfahrer-Buchung direkt und unkompliziert per WhatsApp bestätigen."
}, {
  id: "faq-difference",
  question: "Was ist der Unterschied zwischen einem privaten Fahrer und einem normalen Taxi?",
  answer: "Herkömmliche Taxis bieten reine Punkt-zu-Punkt-Fahrten. Mit einem privaten Fahrer erhalten Sie ein exklusiv für Sie reserviertes Fahrzeug mit Chauffeur, der Ihnen für mehrere Stunden flexibel auf Abruf zur Verfügung steht."
}, {
  id: "faq-child-seat",
  question: "Kann ich einen Kindersitz anfragen?",
  answer: "Ja. Kindersitze können bei der Reservierung im Voraus angefragt werden, um eine sichere Fahrt für Ihre Familie zu gewährleisten."
}];
export default function PrivateDriverFaqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.1
  });
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  };
  return <section id="privatedriverfaqs" data-nav="light" ref={ref} className="bg-background text-foreground py-16 md:py-20 transition-opacity duration-500 ease-out" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} />

      <div className="max-w-[1136px] mx-auto px-6">
        <h2 className="text-accent-foreground font-semibold text-2xl md:text-3xl tracking-tight mb-8 text-center">
          Häufig gestellte Fragen zur Privatfahrer-Miete
        </h2>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-3">
            {FAQS.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="rounded-2xl border border-border bg-secondary/50 overflow-hidden px-6 transition-colors data-[state=open]:bg-secondary/80">
                <AccordionTrigger className="text-left font-medium text-base text-foreground hover:no-underline py-5 focus-visible:ring-0">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5 pt-1">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}